jQuery( function( $ ) {
	$( document ).ready( function() {

		airlinesJS = ( function() {

			var
				init = function() {
					_initTypeSelector();
				},

				/**
				 * Function initializes type selector on archives page
				 *
				 * @author PH
				 * @return void
				 */
				_initTypeSelector = function() {
					$( '#airlines_type_selector-js' ).change( function() {
						if ( $( this ).val() ) {
							window.location.href = $( this ).val();
						}
					});
				}
			;

			return {
				init: init
			};

		}() );

	});
});
